<div class="tc-wrapper">

  <!-- ── Header ── -->
  <div class="tc-header">
    <div class="tc-header-main">
      <div class="tc-icon-wrap">
        <mat-icon>{{ data.title?.toLowerCase().includes('privacidad') ? 'security' : 'description' }}</mat-icon>
      </div>
      <div class="tc-header-text">
        <div class="tc-title">{{ title }}</div>
        <div class="tc-subtitle">Desplázate y lee el documento completo para continuar</div>
      </div>
    </div>
    <div class="tc-progress-row">
      <div class="tc-progress-track">
        <div class="tc-progress-fill" [style.width.%]="scrollProgress"></div>
      </div>
      <span class="tc-progress-label">{{ scrollProgressInt }}%</span>
    </div>
  </div>

  <!-- ── Contenido desplazable ── -->
  <div class="tc-content" #scrollContainer (scroll)="onScroll($event)">
    <div class="tc-inner" [innerHTML]="safeHtml"></div>
  </div>

  <!-- ── Indicador de lectura ── -->
  <div class="tc-read-hint" [class.tc-read-hint--done]="hasScrolledToBottom">
    <mat-icon>{{ hasScrolledToBottom ? 'check_circle' : 'keyboard_arrow_down' }}</mat-icon>
    <span>{{ hasScrolledToBottom ? 'Has leído el documento' : 'Desplázate para leer el documento completo' }}</span>
  </div>

  <!-- ── Pie de página ── -->
  <div class="tc-footer">
    <button mat-stroked-button class="tc-btn-decline" type="button" (click)="close()">
      NO ACEPTO
    </button>
    <button mat-raised-button class="tc-btn-accept" type="button" (click)="accept()" [disabled]="!hasScrolledToBottom">
      <mat-icon>check</mat-icon>
      ACEPTO Y CONTINÚO
    </button>
  </div>

</div>
